import React, { useContext } from "react";
import "./styles/InfoCard.scss";
import ScriptBoxCaller from "../ScriptBoxCaller/ScriptBoxCaller";
import AppContext from "../../context/appContext";
import ReleaseTextIconMarked from "../VectorIcons/ReleaseTextIconMarked";
import useDownloadAttachment from "../../hooks/useDownloadAttachment";
import SmallLoading from "../SmallLoading/SmallLoading";

const InfoCard = (props) => {
  const {
    callerIcon,
    callerEvent,
    cardTitle,
    files,
    havePermission,
    condition,
    isExternal,
    // isMaterial,
    projectId,
    loadingAttachments,
  } = props;

  const context = useContext(AppContext);

  const { downloadAttachment } = useDownloadAttachment();

  if (loadingAttachments)
    return (
      <div className="centerLoading">
        <SmallLoading />
      </div>
    );

  return (
    <div className="infoCard">
      <div className="cardHeader">
        <span className="cardTitle">{cardTitle}</span>
        <div className="uploadButton">
          {!!callerEvent && havePermission && (
            <ScriptBoxCaller callerIcon={callerIcon} event={callerEvent[0]} />
          )}
        </div>
      </div>

      {!!files && !!files?.length ? (
        files.slice(0, 3).map((item, index) => {
          const fileToDownload = {
            fileData: item,
            contentId: projectId,
            origin: "ficha-projeto",
            mode: 0,
          };

          return (
            <div className="cardContent" key={index}>
              <div>
                <span className="attachmentType">
                  {item?.type?.name ?? "-"}
                </span>
                <span className="attachmentDate">
                  {context.convertDatePtBr(
                    item.deliveryControl?.completionDates?.received
                  )}
                </span>
              </div>

              <div className="attachmentInfo">
                {/* TO-DO - Avaliar se o bloco abaixo ainda é usado mesmo, bem como a prop condition */}
                {!!item.type && item?.type?.name === condition && (
                  <>
                    <span className="capInfo">Cap {item.chapterNumber}</span>
                    <span className="blockInfo">Bloco {item.blockNumber}</span>
                  </>
                )}

                {!isExternal && (
                  <span className="attachmentVersion">
                    <span>{!!item.type && `${item.version}ª versão`}</span>
                    {!!item?.releaseManagement?.channel && (
                      <ReleaseTextIconMarked />
                    )}
                  </span>
                )}
              </div>

              <div className="attachmentName">
                <div onClick={() => downloadAttachment(fileToDownload)}>
                  {item.fileName}
                </div>
              </div>
            </div>
          );
        })
      ) : (
        <div className="cardContent">
          <span>Não há nenhum anexo.</span>
        </div>
      )}

      {!!files?.length && (
        <div className="cardContent">
          <div className="allAttachments">
            <ScriptBoxCaller
              callerText="Ver todos os anexos"
              event={callerEvent[1]}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default InfoCard;
